import getRoutes from './routes'
import { routerSetup } from './setup'

// 开发环境默认启用新的路由， 2代表新路由，1代表老路由
const isProd = process.env.NODE_ENV === 'production'
// 开发环境默认启用新的路由， 3代表离屏渲染模板内联，2代表新路由，1代表老路由
const routes = getRoutes(!isProd ? 2 : 1)

export default routerSetup(routes)